import queryString from "query-string";
import { switchOfferType } from "../actions/offerType";
import { switchPortal } from "../actions/portal";
import { updateFilter } from "../actions/filter";
import { updateSort } from "../actions/sort";
import { createParam, paramBase } from "./urlQueryParam";
import { OFFER_TYPES } from "../constants/offerTypes";
import { FILTER_FIELDS } from "../constants/filterFields";
import { convertValues } from "./convertValues";
import * as params from "../constants/urlQueryParams";

function queryFilterToFilter(queryFilterKey, queryFilterValue) {
  const filterKey = queryFilterKey.substring(
    queryFilterKey.lastIndexOf("[") + 1,
    queryFilterKey.lastIndexOf("]")
  );

  let filter = {};
  filter[filterKey] = queryFilterValue;

  return convertValues(filter, FILTER_FIELDS);
}

function dispatchAction(store, clientConfigId, key, value) {
  if (key.indexOf(createParam(clientConfigId, [params.FILTER_PHONE_OFFER])) >= 0) {
    const filter = queryFilterToFilter(key, value);
    store.dispatch(updateFilter(OFFER_TYPES.phoneOffer, filter));
  } else if (
    key.indexOf(createParam(clientConfigId, [params.FILTER_PROPOSITION])) >= 0
  ) {
    const filter = queryFilterToFilter(key, value);
    store.dispatch(updateFilter(OFFER_TYPES.proposition, filter));
  } else if (
    key.indexOf(createParam(clientConfigId, [params.FILTER_SIM_ONLY])) >= 0
  ) {
    const filter = queryFilterToFilter(key, value);
    store.dispatch(updateFilter(OFFER_TYPES.simOnly, filter));
  } else if (key.indexOf(createParam(clientConfigId, [params.OFFER_TYPE])) >= 0) {
    store.dispatch(switchOfferType(value));
  } else if (key.indexOf(createParam(clientConfigId, [params.PORTAL])) >= 0) {
    store.dispatch(switchPortal(value));
  } else if (
    key.indexOf(createParam(clientConfigId, [params.SORT_PHONE_OFFER])) >= 0
  ) {
    store.dispatch(updateSort(OFFER_TYPES.phoneOffer, value));
  } else if (
    key.indexOf(createParam(clientConfigId, [params.SORT_PROPOSITION])) >= 0
  ) {
    store.dispatch(updateSort(OFFER_TYPES.proposition, value));
  } else if (
    key.indexOf(createParam(clientConfigId, [params.SORT_SIM_ONLY])) >= 0
  ) {
    store.dispatch(updateSort(OFFER_TYPES.simOnly, value));
  }
}

const urlQueryToStore = (store, clientConfigId, historySearch) => {
  const urlParams = queryString.parse(historySearch, {
    arrayFormat: "bracket"
  });
  const paramConfigBase = paramBase(clientConfigId);

  for (const key of Object.keys(urlParams)) {
    if (key.indexOf(paramConfigBase) >= 0) {
      dispatchAction(store, clientConfigId, key, urlParams[key]);
    }
  }
};

export default urlQueryToStore;
